<template>
  <div>
    <div
      class="
        my-3
        transition
        duration-150
        ease-in-out
        shadow-md
        hover:shadow-lg
        w-72
        lg:w-80
        mx-auto
        p-4
        rounded-lg
        lg:h-32
        relative
        bg-beige
      "
    >
      <div class="absolute bottom-2 right-2" v-if="edit">
        <div class="inline-flex">
          <!-- <button
            class="
              rounded-full
               
              ml-1
              mt-1
              w-10
              h-10
              bg-orange-tint
              border-2 border-orange
              lg:w-12
              lg:h-12
            "
          >
            <img
              src="data:image/png;base64,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"
              class="mx-auto w-8"
              @click="router.replace(`/classes/swap?class=${desc}`)"
            />
          </button> -->
          <button
            class="
              rounded-full  
              ml-1
              mt-1
              w-10
              h-10
              bg-red-400
              lg:w-12 lg:h-12
            "
            @click="
              () => {
                showModal = true;
                key++;
              }
            "
          >
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAAx0lEQVRIie2WOw7CMBAFZ4GGCk4WLgMnzBHgAoCgDp2Rgh4NBUJZK7GBBJRpV/tG658MIy2RtJJU9CG+SgqfCi8kBXUnJK2GpDJB5lE2OSbZy9Jiji84fgDzCpIqYJGZfzGzZVMhtseHTCnA3it8WuxmDFJ8fIPYzRjkxL2J3RPZATcjdo+nQABmidIamJtZ3VR0JzazG3BOlAKcPGlU/CBnn6O9o/iVnEck2jvYibek/SAE7BL6nhKkjaSqwx+rkrTOko78BXfsv/tfckIKKQAAAABJRU5ErkJggg=="
              class="w-8 mx-auto"
            />
          </button>
        </div>
      </div>
      <div class="w-48">
        <p class="text-lg font-bold truncate lg:text-xl capitalize">
          {{ name }}
        </p>
        <p class="text-extralight truncate">
          {{ desc }}
        </p>
      </div>
    </div>
    <modal :active="showModal" :key="key">
      <div class="w-full mx-auto mb-2 rounded-md bg-red-100">
        <div class="flex w-full justify-center relative">
          <p
            class="
              text-red-400
              font-bold
              text-lg text-center
              py-2
              truncate
              w-60
              capitalize
            "
          >
            {{ name }}
          </p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="animate-pulse w-4 h-4 text-red-400 absolute left-2 top-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
      </div>
      <div class="w-full flex justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="30"
          height="30"
          viewBox="0 0 172 172"
          style="fill: #000000"
          class="w-16 h-16 flex items-center text-red-500 mx-auto mt-6"
        >
          <g
            fill="none"
            fill-rule="nonzero"
            stroke="none"
            stroke-width="1"
            stroke-linecap="butt"
            stroke-linejoin="miter"
            stroke-miterlimit="10"
            stroke-dasharray=""
            stroke-dashoffset="0"
            font-family="none"
            font-weight="none"
            font-size="none"
            text-anchor="none"
            style="mix-blend-mode: normal"
          >
            <path d="M0,172v-172h172v172z" fill="none"></path>
            <g fill="#f87171">
              <path
                d="M85.91042,14.25495c-3.16203,0.04943 -5.68705,2.6496 -5.64375,5.81172v2.86667h-31.53333c-1.53406,-0.02082 -3.01249,0.574 -4.10468,1.65146c-1.09219,1.07746 -1.70703,2.54767 -1.70704,4.08187h-8.52161c-2.06765,-0.02924 -3.99087,1.05709 -5.03322,2.843c-1.04236,1.78592 -1.04236,3.99474 0,5.78066c1.04236,1.78592 2.96558,2.87225 5.03322,2.843h103.2c2.06765,0.02924 3.99087,-1.05709 5.03322,-2.843c1.04236,-1.78592 1.04236,-3.99474 0,-5.78066c-1.04236,-1.78592 -2.96558,-2.87225 -5.03322,-2.843h-8.52161c-0.00001,-1.53421 -0.61486,-3.00442 -1.70704,-4.08187c-1.09219,-1.07746 -2.57061,-1.67228 -4.10468,-1.65146h-31.53333v-2.86667c0.02122,-1.54972 -0.58581,-3.04203 -1.68279,-4.1369c-1.09698,-1.09487 -2.59045,-1.69903 -4.14013,-1.67482zM34.4,51.6l10.27969,87.34375c0.67653,5.77347 5.56348,10.12292 11.37708,10.12292h59.88646c5.8136,0 10.69482,-4.34945 11.37708,-10.12292l10.27969,-87.34375z"
              ></path>
            </g>
          </g>
        </svg>
      </div>
      <h2 class="text-xl font-bold pt-6 pb-2 text-center">Jumping ship?</h2>
      <p class="text-sm text-gray-500 px-8 pb-2 text-center">
        This will delete your class information and you will no longer be
        enrolled
      </p>
      <div class="flex justify-end w-full mx-auto">
        <!-- <button
              class="
                py-2
                mt-4
                w-36
                mx-1
                relative
                rounded-2xl
                 
                font-bold
                text-orange
                bg-orange-tint
              "
              @click="router.replace(`/classes/swap/${desc}`)"
            >
              <img
                class="m-0 w-5 h-5 absolute left-3"
                src="data:image/png;base64,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"
                @click="acceptRequest(session.id)"
              />
              <p class="pl-3 my-0 py-0">swap</p>
            </button> -->
        <button
          class="
            py-2
            mt-4
            w-36
            mx-1
            relative
            text-center
            rounded-2xl  
            font-bold
            bg-red-400
            text-white
          "
          @click="deleteClass()"
        >
          <img
            class="m-0 w-5 h-5 absolute left-3"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAAx0lEQVRIie2WOw7CMBAFZ4GGCk4WLgMnzBHgAoCgDp2Rgh4NBUJZK7GBBJRpV/tG658MIy2RtJJU9CG+SgqfCi8kBXUnJK2GpDJB5lE2OSbZy9Jiji84fgDzCpIqYJGZfzGzZVMhtseHTCnA3it8WuxmDFJ8fIPYzRjkxL2J3RPZATcjdo+nQABmidIamJtZ3VR0JzazG3BOlAKcPGlU/CBnn6O9o/iVnEck2jvYibek/SAE7BL6nhKkjaSqwx+rkrTOko78BXfsv/tfckIKKQAAAABJRU5ErkJggg=="
          />
          <p class="pl-3 my-0 py-0">Delete</p>
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { useRouter } from "vue-router";
import modal from "../modal.vue";

export default {
  data() {
    return {
      showModal: false,
      key: 0,
    };
  },
  props: {
    name: String,
    desc: String,
    id: String,
    edit: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapActions(["remove_class"]),
    async deleteClass() {
      await this.remove_class(this.id);
      this.showModal = false;
      this.key++;
    },
  },
  components: { modal },
  setup() {
    const router = useRouter();
    return { router };
  },
};
</script>
